import { Component, EventEmitter, Input, Output } from "@angular/core";
import { StorageService } from "../../../services/storage.service";

@Component({
  selector: "search-input-dumb",
  templateUrl: "./search-input-dumb.component.html",
  styleUrls: ["./search-input-dumb.component.scss"],
})
export class SearchInputDumbComponent {
  searchHistory: Array<string> = [];
  showHistory: boolean = false;
  searchQuery: string;

  @Input()
  placeholder: string;

  @Output()
  searchClicked: EventEmitter<string> = new EventEmitter<string>();

  constructor(private storageService: StorageService) {
    let searchHistoryRaw = this.storageService.getItem("sh");
    if (searchHistoryRaw != null) {
      this.searchHistory = JSON.parse(searchHistoryRaw);
    }
  }

  onBlur(event) {
    setTimeout(() => {
      this.showHistory = false;
    }, 10);
  }

  onKeyup(event) {
    this.showHistory = this.searchQuery != "" ? false : true;
  }

  onClickHistoryItem(searchQueryHistory) {
    this.searchQuery = searchQueryHistory;
    this.showHistory = false;
    this.onSearchClick();
  }

  onSearchClick() {
    if (this.searchQuery.trim().length > 0) {
      this.searchHistory.unshift(this.searchQuery.trim());
      //store the last 10 searches
      if (this.searchHistory.length > 10) {
        this.searchHistory.length = 10;
      }

      this.storageService.setItem("sh", this.searchHistory);
    }

    this.searchClicked.emit(this.searchQuery.trim());
  }
}
